import { CreatorToolsType, EnhancedExperienceType } from './type'

export const PlansTypeId = {
  Basic: '1',
  Pro: '2',
  ProPls: '3',
} as const

export const EnhancedExperience = {
  UniversalCredits: 'plans_credits',
  LocalRecommendations: 'plans_local_recommendations',
  VideoRecommendations: 'plans_video_recommendations',
  WebsiteRecommendations: 'plans_website_recommendations',
  PalsWithVision: 'plans_vision_with_analysis',
} as const

export const CreatorTools = {
  CreateAdditionalPals: 'plans_create_additional_ai_partners',
  ChangeAppearance: 'plans_change_appearance',
  SelectFromAllVoices: 'plans_select_from_various_voices',
  SelectFromAllPersonalities: 'plans_select_from_various_personalities',
  UploadKnowledgeFiles: 'plans_add_knowledge_files_up_to',
  InsertWebLink: 'plans_add_website_links_up_to',
  PromoteKeyBrandInformation: 'plans_promote_key_brand_information',
  Insight: 'plans_insight',
  BoostPals: 'plans_boost',
  SponsorChats: 'plans_sponsor_chats',
  SyncWithSocialMedia: 'plans_sync_with_social_media',
  AutoPosting: 'plans_auto_posting',
} as const

export const PlansTitle: { [key: string]: 'basic' | 'pro' | 'pro_plus' } = {
  [PlansTypeId['Basic']]: 'basic',
  [PlansTypeId['Pro']]: 'pro',
  [PlansTypeId['ProPls']]: 'pro_plus',
}

export const enhancedExperienceMap: EnhancedExperienceType = {
  [EnhancedExperience.UniversalCredits]: {
    key: EnhancedExperience['UniversalCredits'],
    hint: 'plans_credits_info',
    [PlansTypeId['Basic']]: 150,
    [PlansTypeId['Pro']]: 450,
    [PlansTypeId['ProPls']]: 750,
  },
  [EnhancedExperience.LocalRecommendations]: {
    key: EnhancedExperience['LocalRecommendations'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
    hint: 'plans_local_recommendations_info',
  },
  [EnhancedExperience.VideoRecommendations]: {
    key: EnhancedExperience['VideoRecommendations'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
  },
  [EnhancedExperience.WebsiteRecommendations]: {
    key: EnhancedExperience['WebsiteRecommendations'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
  },
  [EnhancedExperience.PalsWithVision]: {
    key: EnhancedExperience['PalsWithVision'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
    hint: 'plans_vision_with_analysis_info',
  },
}

export const creatorToolsMap: CreatorToolsType = {
  [CreatorTools['CreateAdditionalPals']]: {
    key: CreatorTools['CreateAdditionalPals'],
    [PlansTypeId['Basic']]: 1,
    [PlansTypeId['Pro']]: 2,
    [PlansTypeId['ProPls']]: 3,
    hint: 'plans_create_additional_ai_partners_info',
  },
  [CreatorTools['ChangeAppearance']]: {
    key: CreatorTools['ChangeAppearance'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
  },
  [CreatorTools['SelectFromAllVoices']]: {
    key: CreatorTools['SelectFromAllVoices'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
  },
  [CreatorTools['SelectFromAllPersonalities']]: {
    key: CreatorTools['SelectFromAllPersonalities'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
  },
  // [CreatorTools['UploadKnowledgeFiles']]: {
  //   key: CreatorTools['UploadKnowledgeFiles'],
  //   [PlansTypeId['Basic']]: '200 MB',
  //   [PlansTypeId['Pro']]: '500 MB',
  //   [PlansTypeId['ProPls']]: '1GB',
  //   hint: 'plans_add_knowledge_file_info',
  // },
  // [CreatorTools['InsertWebLink']]: {
  //   key: CreatorTools['InsertWebLink'],
  //   [PlansTypeId['Basic']]: 2,
  //   [PlansTypeId['Pro']]: 5,
  //   [PlansTypeId['ProPls']]: 10,
  //   hint: 'plans_add_website_link_info',
  // },
  // [CreatorTools['PromoteKeyBrandInformation']]: {
  //   key: CreatorTools['PromoteKeyBrandInformation'],
  //   [PlansTypeId['Basic']]: true,
  //   [PlansTypeId['Pro']]: true,
  //   [PlansTypeId['ProPls']]: true,
  //   hint: 'plans_promote_key_brand_information_info',
  // },
  [CreatorTools['Insight']]: {
    key: CreatorTools['Insight'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
    hint: 'plans_insight_info',
  },
  [CreatorTools['BoostPals']]: {
    key: CreatorTools['BoostPals'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
    hint: 'plans_boost_info',
  },
  [CreatorTools['SponsorChats']]: {
    key: CreatorTools['SponsorChats'],
    [PlansTypeId['Basic']]: true,
    [PlansTypeId['Pro']]: true,
    [PlansTypeId['ProPls']]: true,
    hint: 'plans_sponsor_chats_info',
  },
  // [CreatorTools['SyncWithSocialMedia']]: {
  //   key: CreatorTools['SyncWithSocialMedia'],
  //   [PlansTypeId['Basic']]: true,
  //   [PlansTypeId['Pro']]: true,
  //   [PlansTypeId['ProPls']]: true,
  //   hint: 'plans_sync_with_social_media_info',
  // },

  // [CreatorTools['AutoPosting']]: {
  //   key: CreatorTools['AutoPosting'],
  //   [PlansTypeId['Basic']]: true,
  //   [PlansTypeId['Pro']]: true,
  //   [PlansTypeId['ProPls']]: true,
  //   hint: 'plans_auto_posting_info',
  // },
}
